
export default {
  requirements_title: 'Requerimientos Técnicos',
  // tslint:disable-next-line:max-line-length
  requirements_subtitle: 'Revisa e implementa con el área encargada estos requerimientos, antes del lanzamiento de la medición. Con esto evitamos que los correos lleguen a Spam o  se bloquee el acceso a la plataforma para los encuestados.',
  // tslint:disable-next-line:max-line-length
  requirements_text: 'La herramienta OCC Suite requiere de varias condiciones a nivel técnico que deben garantizarse en la red y equipos de su compañía para ofrecer un nivel de servicio, funcionamiento y mantenimiento adecuado.',
  requirements_title_1: 'Acceso a las URLs',
  requirements_title_list_1: 'Permitir el acceso en los computadores de la organización a las URL:',
  requirements_title_listitems_1: [
    'https://occ-solutions.com/',
    'http://suite.occ-solutions.com/',
    'https://suite.occ-solutions.com/',
    'https://por.occ-solutions.com/',
    'http://por.occ-solutions.com/'
  ],
  requirements_title_2: 'Servidores de correo entrante',
  // tslint:disable-next-line:max-line-length
  requirements_title_list_2: 'Habilitar en la entrada al servidor de correos de su compañía de correos enviados masivamente desde las siguientes direcciones:',
  requirements_title_listitems_2: [
    'sendgrid.info',
    'sendgrid.com',
    'sendgrid.net'
  ],
  requirements_title_3: 'Dominios de correo',
  // tslint:disable-next-line:max-line-length
  requirements_title_list_3: 'Habilitar la entrada al servidor de correos de su compañía correos enviados con los dominios y subdominios respectivos:',
  requirements_title_listitems_3: [
    '@occ-solutions.com',
    '@occsolutions.org',
    '@suite.occ-solutions.com',
    '@suite.occsolutions.org'
  ],
  requirements_title_4: 'Navegadores compatibles:',
  requirements_title_list_4: 'La aplicación web funciona adecuadamente en los siguientes navegadores:',
  requirements_title_listitems_4: [
    'Google Chrome (recomendado).',
    'Mozilla Firefox.',
    'Opera.',
    'Microsoft Edge.'
  ]
}
